import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../Configuration/firebase";

const MAX_MESSAGE_LENGTH = 1900;

const logError = async (message, extra = {}) => {
  try {
    await addDoc(collection(db, "errorLogs"), {
      message: String(message || "Unknown error").slice(0, MAX_MESSAGE_LENGTH),
      stack: extra.stack ? String(extra.stack).slice(0, MAX_MESSAGE_LENGTH) : null,
      url: window.location.href,
      userAgent: navigator.userAgent,
      uid: auth.currentUser?.uid || null,
      timestamp: serverTimestamp(),
    });
  } catch (loggingError) {
    // Don't let logging failures cascade - just log locally.
    console.error("Failed to record error log:", loggingError);
  }
};

// Lightweight, no-account-needed error tracking: reports uncaught errors and
// unhandled promise rejections to a write-only Firestore collection. See
// firestore.rules for the errorLogs collection rules and BACKLOG.md for why
// this exists instead of a proper tool like Sentry.
export const initErrorLogger = () => {
  window.addEventListener("error", (event) => {
    logError(event.message, { stack: event.error?.stack });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    logError(reason?.message || String(reason), { stack: reason?.stack });
  });
};
